import { Box } from "@material-ui/core";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { YesNoField } from "components/fields/YesNoField";
import { DeleteButton } from "components/toolbars/DeleteButton";
import DeleteRestoreButtons from "components/toolbars/DeleteRestoreButtons";
import { FieldType } from "entities/FieldType";
import React from "react";
import { Datagrid, FunctionField, TextField } from "react-admin";

import { AddCustomField } from "./AddCustomField";
import { UpdateCustomField } from "./UpdateCustomField";

export const CustomFieldsList = ({ companyId, ...props }) => {
	return (
		<>
			<Box display="flex" justifyContent="right" padding={1}>
				<AddCustomField companyId={companyId} />
			</Box>
			<Datagrid>
				<TextField source="id" label="resources.custom-fields.fields.id" />
				<TextField source="name" label="resources.custom-fields.fields.name" />
				<SelectEnumField
					source="type"
					label="resources.custom-fields.fields.type"
					enumName="field-type"
					enumObj={FieldType}
				/>
				<YesNoField
					source="is_show_on_grid"
					label="resources.custom-fields.fields.is_show_on_grid"
					sortable={false}
				/>
				<FunctionField source="" render={(record) => <UpdateCustomField customField={record} />} />
				<DeleteRestoreButtons
					confirmDeleteStringKey="osfc.dialogs.confirm_delete_custom_field"
					confirmRestoreStringKey="osfc.dialogs.confirm_restore_custom_field"
				/>
			</Datagrid>
		</>
	);
};
